import { Button } from "@material-ui/core";
import React from "react";
import { graphql, gql, ChildProps } from "react-apollo";
import handleMutationError from "../../../utils/handleMutationError";

type GqlSubmitMutationResult = {
  submit_withdrawal_batch: {
    id: string;
  };
};

type Props = ChildProps<
  {
    batchId: string;
    onSubmit: () => void;
  },
  GqlSubmitMutationResult
>;

class SubmitBatchWithdrawalsButton extends React.Component<Props> {
  submit() {
    this.props
      .mutate({
        variables: {
          batchId: this.props.batchId,
        },
      })
      .then(() => this.props.onSubmit())
      .catch((error) => error && handleMutationError(error));
  }

  render() {
    return (
      <Button
        style={{
          backgroundColor: "#4d5a86",
          color: "white",
        }}
        onClick={() => this.submit()}
      >
        Submit
      </Button>
    );
  }
}

const withSubmitWithdrawalBatchMutation = graphql<
  GqlSubmitMutationResult,
  Props
>(
  gql`
    mutation SubmitWithdrawalRequestBatch($batchId: ID!) {
      submit_withdrawal_batch(id: $batchId) {
        id
      }
    }
  `
);

export default withSubmitWithdrawalBatchMutation(SubmitBatchWithdrawalsButton);
